import ActionTypes from './actionTypes';

export const changeSearch = search => ({ type: ActionTypes.SEARCH, search });
